import axios from 'axios';
import QS from 'qs';

//自动切换环境
axios.defaults.baseURL = 'https://www.mnuedu.net/';
//设置超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withcredentials = true
//请求拦截(请求发出前处理请求)
axios.interceptors.request.use((config) => {
    //在发送请求之前如果为post序列化请求参数
    if (config.method === 'post') {
      config.data = config.data;
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

// 响应拦截器（处理响应数据）
axios.interceptors.response.use((res) => {
    //对响应数据做判断，与后台协议统一接口返回格式
    if (res.data.status === 200) { //这个判断可根据实际情况修改
      return Promise.reject(res);
    }
    return res;
  }, (error) => {
    return Promise.reject(error);
  });
// 封装get方法
function get(url, param){
    return new Promise((resolve, reject) =>{
        axios.get(url, param).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    }).catch((e) => {});
}
// 封装post方法
 function post(url, param){

    return new Promise((resolve, reject) =>{
        axios.post(url,param).then(res =>{

          
            resolve(res.data);
        }).catch(err =>{

alert("账号或者密码错误！");
            reject(err.data);
        })
    }).catch((e) => {});
}

//对外接口
export function request({method, url, data}){
    if(method == 'get'){
        return get(url, data);
    }else if(method == 'post'){

        return post(url, data);
    }
}

export default {
    install(Vue) {
    Vue.prototype.$axios = axios;
    Vue.prototype.$request = function () {
            return request;
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/https.js